import { render, staticRenderFns } from "./CountryEdit.vue?vue&type=template&id=0b19d76c&scoped=true&"
import script from "./CountryEdit.vue?vue&type=script&lang=js&"
export * from "./CountryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b19d76c",
  null
  
)

export default component.exports